import React from 'react';

import { CrossCircleIcon } from '@vlabs/icons';
import { ButtonWithPermissions } from '@vlabs/monokit/shared/ui/button-with-permissions';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export function DeleteAndDetachCell({
  onClick, row, permissions, buttonProps,
}) {
  const { t } = useTranslation();
  const { rules = [], method = 'oneof' } = permissions || {};

  return (
    <ButtonWithPermissions
      data-testid="linkBrokenCell"
      icon={<CrossCircleIcon />}
      kind="negative"
      onClick={() => onClick(row.original)}
      permissions={{ rules, method }}
      round
      title={t('lists:table.buttons.delete_and_detach')}
      variant="dimmed"
      {...(buttonProps || {})}
    />
  );
}

DeleteAndDetachCell.propTypes = ({
  row: PropTypes.objectOf(PropTypes.any).isRequired,
  buttonProps: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  permissions: PropTypes.shape({
    rules: PropTypes.arrayOf(PropTypes.string).isRequired,
    method: PropTypes.oneOf(['oneof', 'allof']),
  }),
});

DeleteAndDetachCell.defaultProps = ({
  buttonProps: undefined,
  permissions: {},
});
